/**
 * User Recommend Listener (V1)
 * - addEventListener registration only
 */

import { userRecommendForm } from "./user-recommend-form";

interface UserRecommendHandlerLike {
    handleRecommendClick(event: MouseEvent, el: HTMLElement): Promise<void>;
}

export class UserRecommendListener {
    private static canRecommend(element: HTMLElement): boolean {
        if (element.dataset?.canRecommend === "1") {
            return true;
        }

        let current: Element | null = element.parentElement;
        while (current) {
            if (current instanceof HTMLElement && current.getAttribute("data-can-recommend") === "1") {
                return true;
            }

            current = current.parentElement;
        }

        return false;
    }

    public handler: UserRecommendHandlerLike;

    public _registered: boolean;

    public constructor(deps: { handler: UserRecommendHandlerLike }) {
        this.handler = deps.handler;
        this._registered = false;
    }

    public register(): void {
        if (this._registered) return;
        this._registered = true;

        document.addEventListener(
            "click",
            (event) => {
                if (!(event instanceof MouseEvent)) {
                    return;
                }
                const target = event.target;
                if (!(target instanceof Element)) {
                    return;
                }
                if (!target) return;

                const crownEl = userRecommendForm.getClosestRecommendButton(target);
                if (crownEl instanceof HTMLElement) {
                    const canRecommend = UserRecommendListener.canRecommend(crownEl);
                    if (canRecommend) {
                        void this.handler.handleRecommendClick(event, crownEl);
                    }
                }
            },
            { capture: true },
        );
    }
}
